import {
  ApplicantDataComponentConfig,
  ApplicantDataSectionComponent
} from '../common/applicant-data-section/applicant-data-section.component';
import { Routes } from '@angular/router';
import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from '../common/agreements-data-section/agreements-data-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import {
  ApplicationDataComponentConfig,
  ApplicationDataSectionComponent
} from '../common/application-data-section/application-data-section.component';
import {
  PermitForOversizeVehicleTravelDataSectionComponent
} from './sections/permit-for-oversize-vehicle-travel-data-section/permit-for-oversize-vehicle-travel-data-section.component';
import {
  EntityOrderingTheRideSectionComponent
} from './sections/entity-ordering-the-ride-section/entity-ordering-the-ride-section.component';

export const stages: string[] = [
  'Wnioskodawca',
  'Dane wniosku',
  'Dane przejazdu',
  'Podmiot zlecający przejazd',
  'Zgody',
  'Załączniki'
];

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages
};

export const applicationDataSectionConfig: ApplicationDataComponentConfig = {
  stages,
  addCorrespondenceControls: true,
  addApplicationSubjectControl: true,
  applicationSubjectOptions: [
    'Kategorii I',
    'Kategorii II'
  ],
  applicationSubjectControlType: 'select',
  successUrl: '../dane-przejazdu',
  cancelUrl: '../wnioskodawca'
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../podmiot-zlecajacy',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const permitForOversizeVehiclesRoutes: Routes = [
  {
    component: ApplicantDataSectionComponent,
    path: 'wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicantDataSectionComponent,
    path: ':appId/wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicationDataSectionComponent,
    path: ':appId/dane-wniosku',
    data: applicationDataSectionConfig
  },
  {
    component: PermitForOversizeVehicleTravelDataSectionComponent,
    path: ':appId/dane-przejazdu'
  },
  {
    component: EntityOrderingTheRideSectionComponent,
    path: ':appId/podmiot-zlecajacy'
  },
  {
    component: AgreementsDataSectionComponent,
    path: ':appId/zgody',
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  { path: '', redirectTo: 'wnioskodawca', pathMatch: 'prefix' }
];
